import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/united-states.jpg'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xxl-8" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = {
  class: "tab-content",
  id: "myTab4Content"
}
const _hoisted_6 = {
  class: "tab-pane fade show active",
  id: "preview4-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "preview4-tab",
  tabindex: "0"
}
const _hoisted_7 = { class: "d-flex gap-sm-3 gap-lg-4" }
const _hoisted_8 = { class: "product-quantity" }
const _hoisted_9 = { class: "product-quantity bg-e2e8f0" }
const _hoisted_10 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_11 = { class: "card-body p-4" }
const _hoisted_12 = {
  class: "tab-content",
  id: "myTab5Content"
}
const _hoisted_13 = {
  class: "tab-pane fade show active",
  id: "preview5-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "preview5-tab",
  tabindex: "0"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-6" }
const _hoisted_16 = { class: "product-quantity w-100" }
const _hoisted_17 = { class: "col-lg-6" }
const _hoisted_18 = { class: "product-quantity w-100 bg-e2e8f0" }
const _hoisted_19 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_20 = { class: "card-body p-4 pb-0" }
const _hoisted_21 = {
  class: "tab-content",
  id: "myTab6Content"
}
const _hoisted_22 = {
  class: "tab-pane fade show active",
  id: "preview6-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "preview6-tab",
  tabindex: "0"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-lg-3 col-sm-6 mb-4" }
const _hoisted_25 = { class: "product-quantity" }
const _hoisted_26 = { class: "col-lg-3 col-sm-6 mb-4" }
const _hoisted_27 = { class: "product-quantity bg-e2e8f0" }
const _hoisted_28 = { class: "col-lg-3 col-sm-6 mb-4" }
const _hoisted_29 = { class: "product-quantity" }
const _hoisted_30 = { class: "col-lg-3 col-sm-6" }
const _hoisted_31 = { class: "product-quantity" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuantityCounter = _resolveComponent("QuantityCounter")!
  const _component_QuantityCounterTwo = _resolveComponent("QuantityCounterTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Select Components"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col-lg-4" }, [
                  _createElementVNode("div", { class: "form-group mb-4" }, [
                    _createElementVNode("label", { class: "label text-secondary" }, "Default Select"),
                    _createElementVNode("div", { class: "form-group position-relative" }, [
                      _createElementVNode("select", {
                        class: "form-select form-control h-60",
                        "aria-label": "Default select example"
                      }, [
                        _createElementVNode("option", {
                          selected: "",
                          class: "text-dark"
                        }, "Value 1"),
                        _createElementVNode("option", {
                          value: "1",
                          class: "text-dark"
                        }, "Value 2"),
                        _createElementVNode("option", {
                          value: "2",
                          class: "text-dark"
                        }, "Value 3"),
                        _createElementVNode("option", {
                          value: "3",
                          class: "text-dark"
                        }, "Value 4")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "col-lg-4" }, [
                  _createElementVNode("div", { class: "form-group mb-4" }, [
                    _createElementVNode("label", { class: "label text-secondary" }, "Multi Tags"),
                    _createElementVNode("div", {
                      class: "tag-container p-1 rounded-3 form-control h-auto p-0",
                      id: "tagContainer"
                    }, [
                      _createElementVNode("input", {
                        type: "text",
                        id: "tagInput",
                        class: "form-control h-49 border-0",
                        placeholder: "Type and press Enter"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "col-lg-4" }, [
                  _createElementVNode("div", { class: "form-group mb-4" }, [
                    _createElementVNode("label", { class: "label text-secondary" }, "Taggable Select"),
                    _createElementVNode("div", { class: "form-group position-relative" }, [
                      _createElementVNode("select", {
                        class: "form-select form-control h-60",
                        "aria-label": "Default select example"
                      }, [
                        _createElementVNode("option", {
                          selected: "",
                          class: "text-dark"
                        }, "Trezo"),
                        _createElementVNode("option", {
                          value: "1",
                          class: "text-dark"
                        }, "Seku"),
                        _createElementVNode("option", {
                          value: "2",
                          class: "text-dark"
                        }, "Adlo"),
                        _createElementVNode("option", {
                          value: "3",
                          class: "text-dark"
                        }, "Orla")
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"row\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <label class=\"label text-secondary\">Default Select</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <select class=\"form-select form-control h-60\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <option selected class=\"text-dark\">Value 1</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <option value=\"1\" class=\"text-dark\">Value 2</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <option value=\"2\" class=\"text-dark\">Value 3</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <option value=\"3\" class=\"text-dark\">Value 4</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <label class=\"label text-secondary\">Multi Tags</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"tag-container p-1 rounded-3 form-control h-auto p-0\" id=\"tagContainer\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <input type=\"text\" id=\"tagInput\" class=\"form-control h-49 border-0\" placeholder=\"Type and press Enter\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <label class=\"label text-secondary\">Taggable Select</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <select class=\"form-select form-control h-60\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <option selected class=\"text-dark\">Trezo</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <option value=\"1\" class=\"text-dark\">Seku</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <option value=\"2\" class=\"text-dark\">Adlo</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <option value=\"3\" class=\"text-dark\">Orla</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)),
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-lg-12" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Custom country select input"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTab2Content"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("form", null, [
                _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("div", { class: "col-lg-4" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "Default Select"),
                      _createElementVNode("div", { class: "form-group position-relative" }, [
                        _createElementVNode("select", {
                          class: "form-select form-control h-60",
                          "aria-label": "Default select example"
                        }, [
                          _createElementVNode("option", {
                            selected: "",
                            class: "text-dark"
                          }, "Value 1"),
                          _createElementVNode("option", {
                            value: "1",
                            class: "text-dark"
                          }, "Value 2"),
                          _createElementVNode("option", {
                            value: "2",
                            class: "text-dark"
                          }, "Value 3"),
                          _createElementVNode("option", {
                            value: "3",
                            class: "text-dark"
                          }, "Value 4")
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-4" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "Multi Tags"),
                      _createElementVNode("div", { class: "col-12" }, [
                        _createElementVNode("label", {
                          class: "visually-hidden",
                          for: "inlineFormInputGroupUsername"
                        }, "Enter number"),
                        _createElementVNode("div", { class: "input-group h-60 form-control p-0" }, [
                          _createElementVNode("div", { class: "input-group-text rounded-3 px-3" }, [
                            _createElementVNode("img", {
                              src: _imports_0,
                              alt: "united-states"
                            }),
                            _createElementVNode("span", { class: "ms-3 text-dark" }, "+1")
                          ]),
                          _createElementVNode("input", {
                            type: "number",
                            class: "form-control h-auto border-0 text-dark",
                            id: "inlineFormInputGroupUsername",
                            placeholder: "Enter number"
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-4" }, [
                    _createElementVNode("div", { class: "form-group mb-4" }, [
                      _createElementVNode("label", { class: "label text-secondary" }, "Taggable Select"),
                      _createElementVNode("div", { class: "form-group position-relative" }, [
                        _createElementVNode("select", {
                          class: "form-select form-control h-60 ps-5",
                          "aria-label": "Default select example"
                        }, [
                          _createElementVNode("option", {
                            selected: "",
                            class: "text-dark"
                          }, " United States "),
                          _createElementVNode("option", {
                            value: "1",
                            class: "text-dark"
                          }, " United Kingdom "),
                          _createElementVNode("option", {
                            value: "2",
                            class: "text-dark"
                          }, "Germany")
                        ]),
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "position-absolute top-50 start-0 translate-middle-y ps-3",
                          alt: "united-states"
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<form>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"row\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">Default Select</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <select class=\"form-select form-control h-60\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option selected class=\"text-dark\">Value 1</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"1\" class=\"text-dark\">Value 2</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"2\" class=\"text-dark\">Value 3</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"3\" class=\"text-dark\">Value 4</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">Multi Tags</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"col-12\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <label class=\"visually-hidden\" for=\"inlineFormInputGroupUsername\">Enter number</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <div class=\"input-group h-60 form-control p-0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <div class=\"input-group-text rounded-3 px-3\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <img src=\"@/assets/images/united-states.jpg\" alt=\"united-states\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                            <span class=\"ms-3 text-dark\">+1</span>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <input type=\"number\" class=\"form-control h-auto border-0 text-dark\" id=\"inlineFormInputGroupUsername\" placeholder=\"Enter number\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <div class=\"col-lg-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <div class=\"form-group mb-4\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <label class=\"label text-secondary\">Taggable Select</label>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <div class=\"form-group position-relative\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <select class=\"form-select form-control h-60 ps-5\" aria-label=\"Default select example\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option selected class=\"text-dark\">United States</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"1\" class=\"text-dark\">United Kingdom</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                        <option value=\"2\" class=\"text-dark\">Germany</option>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    </select>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                    <img src=\"@/assets/images/united-states.jpg\" class=\"position-absolute top-50 start-0 translate-middle-y ps-3\" alt=\"united-states\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</form>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)),
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-xxl-4" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "By Date"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTab3Content"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex align-items-center mb-4 gap-5" }, [
                _createElementVNode("div", { class: "form-check" }, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: "",
                    id: "flexCheckDefault"
                  }),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: "flexCheckDefault"
                  }, " This Week ")
                ]),
                _createElementVNode("div", { class: "form-check" }, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: "",
                    id: "flexCheckDefault2"
                  }),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: "flexCheckDefault2"
                  }, " Last Week ")
                ])
              ]),
              _createElementVNode("div", { class: "d-flex align-items-center mb-4 gap-5" }, [
                _createElementVNode("div", { class: "form-check" }, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: "",
                    id: "flexCheckDefault3"
                  }),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: "flexCheckDefault3"
                  }, " This Month ")
                ]),
                _createElementVNode("div", { class: "form-check" }, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: "",
                    id: "flexCheckDefault4"
                  }),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: "flexCheckDefault4"
                  }, " Last Month ")
                ])
              ]),
              _createElementVNode("div", { class: "d-flex align-items-center mb-4 gap-5" }, [
                _createElementVNode("div", { class: "form-check" }, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: "",
                    id: "flexCheckDefault5"
                  }),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: "flexCheckDefault5"
                  }, " This Year ")
                ]),
                _createElementVNode("div", { class: "form-check" }, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: "",
                    id: "flexCheckDefault6"
                  }),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: "flexCheckDefault6"
                  }, " Last Year ")
                ])
              ]),
              _createElementVNode("div", { class: "border-top border-bottom py-3 mb-4" }, [
                _createElementVNode("div", { class: "form-check" }, [
                  _createElementVNode("input", {
                    class: "form-check-input rounded-1",
                    style: {"background-image":"unset"},
                    type: "radio",
                    name: "flexRadioDefault",
                    id: "flexRadioDefault1"
                  }),
                  _createElementVNode("label", {
                    class: "form-check-label text-dark fs-14",
                    for: "flexRadioDefault1"
                  }, " Date Range ")
                ])
              ]),
              _createElementVNode("div", { class: "calendar-content" }, [
                _createElementVNode("h1", { id: "month-year" }),
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "S"),
                      _createElementVNode("th", null, "M"),
                      _createElementVNode("th", null, "T"),
                      _createElementVNode("th", null, "W"),
                      _createElementVNode("th", null, "T"),
                      _createElementVNode("th", null, "F"),
                      _createElementVNode("th", null, "S")
                    ])
                  ]),
                  _createElementVNode("tbody", { id: "calendar-body" })
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"calendar-content\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <h1 id=\"month-year\"></h1>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <table id=\"calendar\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <thead>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            <tr>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <th>S</th>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <th>M</th>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <th>T</th>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <th>W</th>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <th>T</th>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <th>F</th>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "                <th>S</th>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "            </tr>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        </thead>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <tbody id=\"calendar-body\"></tbody>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </table>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Custom Touch Spin", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab4",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _cache[0] || (_cache[0] = _createElementVNode("label", { class: "label d-block" }, "Default", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_QuantityCounter, { class: "gap-2" })
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[1] || (_cache[1] = _createElementVNode("label", { class: "label d-block" }, "Light", -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_QuantityCounter, { class: "gap-2" })
                  ])
                ])
              ])
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"product-quantity\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"add-to-cart-counter gap-2\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"minusBtn\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <inputtype=\"text\"size=\"25\"value=\"1\"class=\"count\"/>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"plusBtn\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"product-quantity bg-e2e8f0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"add-to-cart-counter gap-2\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"minusBtn\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <inputtype=\"text\"size=\"25\"value=\"1\"class=\"count\"/>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"plusBtn\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "(Full width) Custom Touch Spin", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab5",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview5-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code5-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label d-block" }, "Default", -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_QuantityCounter, { class: "gap-2 justify-content-between" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label d-block" }, "Light", -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_QuantityCounter, { class: "gap-2 justify-content-between" })
                  ])
                ])
              ])
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode5"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode5"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"product-quantity w-100\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"add-to-cart-counter gap-2 justify-content-between\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"minusBtn\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <inputtype=\"text\"size=\"25\"value=\"1\"class=\"count\"/>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"plusBtn\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"product-quantity w-100 bg-e2e8f0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"add-to-cart-counter gap-2 justify-content-between\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"minusBtn\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <inputtype=\"text\"size=\"25\"value=\"1\"class=\"count\"/>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"plusBtn\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[15] || (_cache[15] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Custom Touch Spin Colors", -1)),
          _cache[16] || (_cache[16] = _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab6",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview6-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code6-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label d-block" }, "Colored-1", -1)),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_QuantityCounterTwo, {
                      class: "gap-3 justify-content-between",
                      btnColor: "bg-primary text-white"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label d-block" }, "Colored-2", -1)),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_QuantityCounterTwo, {
                      class: "gap-3 justify-content-between",
                      btnColor: "bg-white text-primary",
                      bgClass: "bg-primary text-white"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label d-block" }, "Colored-3", -1)),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_QuantityCounterTwo, {
                      class: "gap-3 justify-content-between",
                      btnColor: "bg-danger text-white",
                      bgClass: "border-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label d-block" }, "Colored-4", -1)),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_QuantityCounterTwo, {
                      class: "gap-3 justify-content-between",
                      btnColor: "bg-success text-white",
                      bgClass: "border-success"
                    })
                  ])
                ])
              ])
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode6"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode6"
                }, [
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"product-quantity\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"add-to-cart-counter gap-3 justify-content-between\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"minusBtn bg-primary text-white\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <inputtype=\"text\"size=\"25\"value=\"1\"class=\"count\"/>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"plusBtn bg-primary text-white\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"product-quantity bg-e2e8f0\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"add-to-cart-counter gap-3 justify-content-between\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"minusBtn bg-white text-primary\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <inputtype=\"text\"size=\"25\"value=\"1\"class=\"count bg-primary text-white\"/>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"plusBtn bg-white text-primary\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"product-quantity\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"add-to-cart-counter gap-3 justify-content-between\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"minusBtn bg-danger text-white\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <inputtype=\"text\"size=\"25\"value=\"1\"class=\"count border-danger\"/>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"plusBtn bg-danger text-white\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "<div class=\"product-quantity\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    <div class=\"add-to-cart-counter gap-3 justify-content-between\">"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"minusBtn bg-success text-white\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <inputtype=\"text\"size=\"25\"value=\"1\"class=\"count border-success\"/>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "        <button type=\"submit\" class=\"plusBtn bg-success text-white\"></button>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "    </div>"),
                  _createTextVNode("\n"),
                  _createElementVNode("div", null, "</div>"),
                  _createTextVNode("\n")
                ]),
                _createTextVNode("\n")
              ])
            ], -1))
          ])
        ])
      ])
    ])
  ]))
}